import axios from "axios";
const URL = "https://api.tangentmusic.live";
export const axiosInstance = axios.create({
  baseURL: URL,
});
export const login = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/login`, data);
  return res;
};

export const getDash = async () => {
  const { data: res } = await axios.get(`${URL}/admin/dashboard`);
  return res;
};

export const getMusic = async () => {
  const { data: res } = await axios.get(`${URL}/admin/musics`);
  return res;
};

export const getMusicFromSubscription = async (id) => {
  const { data: res } = await axios.get(
    `${URL}/admin/subscription-music/${id}`
  );
  return res;
};

export const getAlbumFromSubscription = async (id) => {
  const { data: res } = await axios.get(
    `${URL}/admin/subscription-album/${id}`
  );
  return res;
};

export const deleteMusic = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/music/${id}`);
  return res;
};

export const addMusic = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/music`, data);
  return res;
};

export const updateMusic = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/music/${id}`, data);
  return res;
};

export const getGenres = async () => {
  const { data: res } = await axios.get(`${URL}/admin/genres`);
  return res;
};

export const getAllArtists = async () => {
  const { data: res } = await axios.get(`${URL}/admin/artists`);
  return res;
};
export const getAllSubscriptions = async () => {
  const { data: res } = await axios.get(`${URL}/admin/subscriptions`);
  return res;
};
export const getAllAlbum = async () => {
  const { data: res } = await axios.get(`${URL}/admin/albums`);
  return res;
};

export const updateAlbum = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/album/${id}`, data);
  return res;
};

export const deleteAlbum = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/album/${id}`);
  return res;
};
export const getImage = (data) => {
  return data?.file?.response?.url ?? null;
};

export const addAlbum = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/album`, data);
  return res;
};

export const updateGenres = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/genre/${id}`, data);
  return res;
};

export const deleteGenres = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/genre/${id}`);
  return res;
};

export const deleteArtists = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/artist/${id}`);
  return res;
};
export const getBanners = async () => {
  const { data } = await axios.get(`${URL}/admin/banners`);
  return data;
};
export const addBanner = async (data2) => {
  const { data } = await axios.post(`${URL}/admin/banner`, data2);
  return data;
};

export const updateBanner = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/banner/${id}`, data);
  return res;
};

export const deleteBanner = async (id) => {
  const { data } = await axios.delete(`${URL}/admin/banner/${id}`);
  return data;
};
export const addAdmin = async (data2) => {
  const { data } = await axios.post(`${URL}/admin/signup`, data2);
  return data;
};
export const deleteAdmin = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/delete-admin/${id}`);
  return res;
};
export const addNotification = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/notification`, data);
  return res;
};
export const updateAdmin = async (data, id) => {
  const response = await axios.put(`${URL}/admin/admin-update/${id}`, data);
  return response.data;
};
export const getAllAdmins = async () => {
  const { data: res } = await axios.get(`${URL}/admin/all-admin`);
  return res;
};
export const updateSystemValues = async (data) => {
  const { data: res } = await axios.put(`${URL}/admin/system-values`, data);
  return res;
};
export const getSystemValue = async () => {
  const { data } = await axios.get(`${URL}/admin/system-values`);
  return data;
};
export const addGenres = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/genre`, data);
  return res;
};

export const addArtist = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/artist`, data);
  return res;
};
export const addSubscription = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/subscription`, data);
  return res;
};

export const updateSubscription = async (id, data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/subscription/${id}`,
    data
  );
  return res;
};

export const deleteSubscription = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/subscription/${id}`);
  return res;
};

export const updateArtist = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/artist/${id}`, data);
  return res;
};

export const deleteArtist = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/artist/${id}`);
  return res;
};

export const getAllCategories = async () => {
  const { data: res } = await axios.get(`${URL}/admin/categories`);
  return res;
};

export const addCategory = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/category`, data);
  return res;
};

export const updateCategory = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/category/${id}`, data);
  return res;
};

export const deleteCategory = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/category/${id}`);
  return res;
};

export const addToSub = async (data) => {
  const { data: res } = await axios.put(`${URL}/admin/subscription-add`, data);
  return res;
};

export const addToCategoryAl = async (data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/category/add-album`,
    data
  );
  return res;
};
export const addToCategoryM = async (data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/category/add-music`,
    data
  );
  return res;
};

export const getUsers = async (page) => {
  const { data: res } = await axios.get(
    `${URL}/admin/users?page=${page}&limit=20`
  );
  return res;
};

export const deleteUser = async (id) => {
  const { data: res } = await axios.delete(`${URL}/admin/user/${id}`);
  return res;
};

export const updateUser = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/user/${id}`, data);
  return res;
};

export const addUser = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/user`, data);
  return res;
};

export const getRentHistory = async (id) => {
  const { data: res } = await axios.get(`${URL}/admin/user-rent/${id}`);
  return res;
};

export const userWallet = async (id) => {
  const { data: res } = await axios.get(`${URL}/admin/user-wallet/${id}`);
  return res;
};

export const addRental = async (data) => {
  const { data: res } = await axios.post(`${URL}/admin/user-add-rent`, data);
  return res;
};
export const addWallet = async (id, data) => {
  const { data: res } = await axios.put(`${URL}/admin/user-wallet/${id}`, data);
  return res;
};
export const addSubs = async (data) => {
  const { data: res } = await axios.put(`${URL}/admin/user-subscription`, data);
  return res;
};

export const getSubscriptionHistory = async (id) => {
  const { data: res } = await axios.get(
    `${URL}/admin/user-subscription-history/${id}`
  );
  return res;
};

export const getNotificationByUser = async (id) => {
  const { data: res } = await axios.get(
    `${URL}/admin/user-notifications/${id}`
  );
  return res;
};

export const removeSubscription = async (data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/subscription-remove`,
    data
  );
  return res;
};

export const getUploadRequests = async () => {
  const { data: res } = await axios.get(`${URL}/admin/upload-content-request`);
  return res;
};

export const acceptUploadRequest = async (data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/approve-upload-content`,
    data
  );
  return res;
};

export const deleteUploadRequest = async (id) => {
  const { data: res } = await axios.put(`${URL}/admin/delete-upload-content`, {
    requestId: id,
  });
  return res;
};

export const rejectUploadContentRequest = async (data) => {
  const { data: res } = await axios.put(
    `${URL}/admin/reject-upload-content`,
    data
  );
  return res;
};

export const getRedeemRequest = async () => {
  const res = await axiosInstance.get("/admin/redeem-requests");
  return res.data;
};

export const acceptDenyRedeemRequest = async (id, request) => {
  const res = await axiosInstance.put(`/admin/redeem-request/${id}`, request);
  return res.data;
};
